export enum FileExportType {
    CSV = 0,
    PDF = 1
}